import {red, green, orange} from '@mui/material/colors';

export const SWAP_RATING_CONFIG_MAP = {
    OK: {
        color: green[400],
        sortOrder: 1,
        text: 'OK'
    },
    WARNING: {
        color: orange[300],
        sortOrder: 2,
        text: 'WARNING'
    },
    CRITICAL: {
        color: red[400],
        sortOrder: 3,
        text: 'CRITICAL'
    },
    UNKNOWN: {
        color: 'white',
        sortOrder: 4,
        text: 'UNKNOWN'
    }
}